import { Parameters } from 'DVWebNodeUtils'
import { makeUrl, MakeUrlArgs} from './urlGen'
export { makeUrl, MakeUrlArgs }

const detailPath = '/detail/'

export interface IUrlData {
  parameters: Parameters
  originalURI: string
  isRetail: boolean
}

export function buildSignInUrl(urlData: IUrlData, refTag: string, returnUrl: string) {
  return makeUrl('/auth-redirect', {
    urlData,
    refTag,
    get: { returnUrl, signin: '1' }
  })
}

export const detailPagePath = (titleId: string) => `${detailPath}${titleId}`

export function buildDetailPageUrl(urlData: IUrlData, titleId: string, refTag: string) {
  return makeUrl(detailPagePath(titleId), { urlData, refTag })
}
